// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : parts for jobs
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import { loadLazy } from 'uix/parts';
import log from 'uix/logging';
// ---Local imports
// ---Exports
export const JobSearch = loadLazy(()=>import(/* webpackChunkName: 'jobs' */ './run'));
export const JobInfo = loadLazy(()=>import(/* webpackChunkName: 'jobs' */ './info'));
export const JobList = loadLazy(()=>import(/* webpackChunkName: 'jobs' */ './list'));
export const SchedulerPanel = loadLazy(()=>import(/* webpackChunkName: 'jobs' */ './scheduler'));
